import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  const toggle = (id: string) => setOpenId((current) => (current === id ? null : id));

  return (
    <section id="faq" className="scroll-mt-28 py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="访问中遇到问题？先看这里"
          desc="整理了用户最常问到的几个问题，点击标题即可展开查看解答。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <ul className="space-y-3">
              {faqs.map((faq) => {
                const open = openId === faq.id;
                return (
                  <li
                    key={faq.id}
                    className={`rounded-lg border transition-colors ${
                      open ? "border-primary-300 bg-primary-100/30" : "border-background-200 bg-background-50"
                    }`}
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => toggle(faq.id)}
                        aria-expanded={open}
                        aria-controls={`${faq.id}-panel`}
                        className="w-full flex items-center justify-between gap-4 text-left p-4 md:p-5 cursor-pointer"
                      >
                        <span className="font-heading font-bold text-sm md:text-base text-foreground-950">
                          {faq.q}
                        </span>
                        <i
                          className={`shrink-0 text-lg text-primary-600 transition-transform ${
                            open ? "ri-subtract-line" : "ri-add-line"
                          }`}
                          aria-hidden="true"
                        />
                      </button>
                    </h3>
                    {open ? (
                      <div id={`${faq.id}-panel`} className="px-4 md:px-5 pb-5 -mt-1">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                      </div>
                    ) : null}
                  </li>
                );
              })}
            </ul>
          </div>

          <aside className="p-5 md:p-6 rounded-lg bg-accent-100/60 border border-accent-200 h-fit">
            <h3 className="font-heading font-bold text-base text-accent-900">还是打不开？</h3>
            <ul className="mt-4 space-y-3 text-sm text-accent-900/90 leading-relaxed">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0" aria-hidden="true" />
                依次尝试本页列出的全部线路
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0" aria-hidden="true" />
                清除浏览器缓存后重新加载页面
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0" aria-hidden="true" />
                在 Wi-Fi 与移动数据之间切换网络
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0" aria-hidden="true" />
                隔一段时间后再访问，等待维护结束
              </li>
            </ul>
            <a
              href="#latest-address"
              className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-accent-600 hover:bg-accent-700 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-refresh-line" aria-hidden="true" />
              返回线路列表重试
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}